import { observer } from 'mobx-react-lite'
import { useActivation } from '@/hooks/view-model-hooks'
import { MergeAccountsScreen } from '@/features/admin/account-linking/MergeAccountsScreen'
import { MergeRequestsTableContainer } from '@/features/admin/account-linking/components/MergeRequestsTable/MergeRequestsTableContainer'
import { MergeAccountsDialogContainer } from '@/features/admin/account-linking/MergeAccountsDialog/MergeAccountsDialogContainer'
import { RejectMergeDialogContainer } from '@/features/admin/account-linking/RejectMergeDialog/RejectMergeDialogContainer'
import { IgnoreMergeRequestDialogContainer } from '@/features/admin/account-linking/IgnoreMergeRequestDialog/IgnoreMergeRequestDialogContainer'
import { type AccountMergeRequestsViewModel } from '@/features/admin/account-linking/AccountMergeRequestsViewModel'

export interface MergeAccountsScreenContainerProps {
  vm: AccountMergeRequestsViewModel
}

export const MergeAccountsScreenContainer = observer(
  function MergeAccountsScreenContainer({
    vm,
  }: MergeAccountsScreenContainerProps) {
    useActivation(vm)

    return (
      <>
        <MergeAccountsScreen
          filterOption={vm.searcher.filterOption}
          onFilterOptionChange={vm.searcher.setFilterOption}
          total={vm.total}
        >
          <MergeRequestsTableContainer vm={vm} />
        </MergeAccountsScreen>
        <MergeAccountsDialogContainer vm={vm.mergeAccountsDialogVm} />
        <RejectMergeDialogContainer vm={vm.rejectMergeDialogVm} />
        <IgnoreMergeRequestDialogContainer vm={vm.ignoreMergeRequestVm} />
      </>
    )
  },
)
